// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/iconfont/material-icons.css
// module id = 577
// module chunks = 1